import * as M from './model';
import { eventTypes } from './model';
import { apiTokenOf, isLoginEvent } from '../user';


const makeTransduce = ({fetchAllDeployments}) => getState => event => {

    event = event || {};

    if (event.type === eventTypes.DEPLOYMENTS_REQUESTED) {
        const token = apiTokenOf(getState());
        return fetchAllDeployments(token)
            .then(M.createDeploymentsReceived)
            .then(x => [x])
            .catch(() => ([M.createDeploymentsRetrievalFailed()]));
    }

    if (isLoginEvent(event)) {
        return Promise.resolve([
            M.createDeploymentsRequested()
        ]);
    }

    return Promise.resolve([]);

};


export { makeTransduce };



// WEBPACK FOOTER //
// ./src/deployments/transducer.js